<script>
export let url_params;
export let free_agents;
// export let active_free_agents;


$: {
	// console.log(url_params);



}


</script>


<style>


</style>



<div class="columns is-variable is-2" style="margin-bottom: 1.25rem;">

	<!-- <div class="column">

		<input class="input" placeholder="Search Free Agents">

	</div> -->

	<div class="column is-narrow">

		<!-- <input class="input" placeholder="..."> -->
		<div class="field">

			<div class="control">

				<div class="select">

					<select bind:value={url_params['position']}>
						<option value="">Position</option>
						<option value="forward">Forward</option>
						<option value="def">Defencemen</option>
						<option value="goalie">Goalie</option>
					</select>

				</div>

			</div>

		</div>


	</div>


	<div class="column is-narrow">

		<!-- <input class="input" placeholder="..."> -->
		<div class="field">

			<div class="control">

				<div class="select">

					<select bind:value={url_params['birth_year']}>
						<option value="">Birth Year</option>
						<option value="2016">2016</option>
						<option value="2015">2015</option>
						<option value="2014">2014</option>
						<option value="2013">2013</option>
						<option value="2012">2012</option>
						<option value="2011">2011</option>
						<option value="2010">2010</option>
						<option value="2009">2009</option>
						<option value="2008">2008</option>
						<option value="2007">2007</option>
						<option value="2006">2006</option>
					</select>

				</div>

			</div>

		</div>


	</div>


	<div class="column is-narrow">

		<!-- <input class="input" placeholder="..."> -->
		<div class="field">

			<div class="control">

				<div class="select">

					<select bind:value={url_params['level']}>
						<option value="">Last Team Level</option>
						<option value="aaa">AAA</option>
						<option value="aa">AA</option>
						<option value="a">A</option>
						<option value="b">B</option>
						<option value="recreational">Recreational</option>
					</select>

				</div>

			</div>

		</div>


	</div>

	<div class="column is-narrow">

		<!-- <input class="input" placeholder="..."> -->
		<div class="field">

			<div class="control">

				<div class="select">

					<select bind:value={url_params['province']}>
						<option value="">Province</option>
						<option value="nb">NB</option>
						<option value="ns">NS</option>
						<option value="pei">PEI</option>
						<option value="nl">NL</option>
						<option value="qc">QC</option>
					</select>

				</div>

			</div>

		</div>

	</div>

</div>


<!-- ... -->

<!-- inputs... -->
<!-- offline search -->



